import '.fs{padding:16px 8px;}.ssr-plugin'
import '.ah{position:fixed;}.ssr-plugin'
import '.ep{z-index:1;}.ssr-plugin'
import '.d8{bottom:0px;}.ssr-plugin'
import '.ae{left:0px;}.ssr-plugin'
import '.cf{right:0px;}.ssr-plugin'
import '.bu{display:none;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.ft{padding:16px 16px 16px 32px;}.ssr-plugin'
import '.bc{border-radius:40px;}.ssr-plugin'
import '.cw{gap:48px;}.ssr-plugin'
import '.fu{max-width:1312px;}.ssr-plugin'
import '.ak{margin:0 auto;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.fv{padding-top:8px;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { Button } from './Button.js'
import { Icon } from '../assets/icons/index.js'
import { Meter } from './Meter.js'
import { useLocation } from 'wouter'
import { TABLET } from '../utils/breakpoints.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { useDictionary } from '../hooks/useDictionary.js'

export const Banner = ({ total, maxVotes }) => {
  const [, setLocation] = useLocation()
  const dictionary = useDictionary()

  return (
    <styled.div className="fs ah ep d8 ae cf bu"
      style={{
        background: `linear-gradient(0deg,${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,
        [TABLET]: {
          display: !total ? 'none' : 'block',
        },
      }}
    >
      <styled.div className="blur o v am ft bc cw fu ak"
        style={{
          border: `1px solid ${colors.border}`,
          backgroundColor: transparentColor(colors.secondary, 0.3),
          animation: MODAL_PANEL_ANIMATION,
          [TABLET]: {
            maxWidth: '480px',
          },
        }}
      >
        <div className="f ag fv"
        >
          <Meter
            value={(total / maxVotes) * 100}
            style={{ marginBottom: 12 }}
          />
          <styled.p>{dictionary.nOutOfMaxVotes}</styled.p>
        </div>
        <Button
          trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
          onClick={() => setLocation('/cart')}
        >
          {dictionary.cart}
        </Button>
      </styled.div>
    </styled.div>
  )
}
